<template>
  <div>
    <v-dialog :model-value="confirmSave" @update:model-value="close" max-width="800px" persistent>
      <v-card elevation="2">
        <v-card-title class="text-h6 bg-primary">Dados da Inscrição</v-card-title>
        <v-card-text>
          <v-container fluid>
            <v-row dense class="border-sm pa-4 rounded-lg">
              <!-- Nome do candidato -->
              <v-col cols="12" md="6">
                <strong>Nome do candidato:</strong> {{ candidateDisplayName }}
              </v-col>

              <!-- Documento -->
              <v-col cols="12" md="4">
                <strong>Data de nascimento:</strong> {{ data.date_of_birth || '—' }}
              </v-col>
              <v-col cols="12" md="4">
                <strong>Gênero:</strong> {{ data.gender || '—' }}
              </v-col>
              <v-col cols="12" md="4">
                <strong>Estado civil:</strong> {{ data.marital_status || '—' }}
              </v-col>

              <!-- Documentos -->
              <v-col cols="12" md="4">
                <strong>RG:</strong> {{ data.rg || '—' }}
              </v-col>
              <v-col cols="12" md="4">
                <strong>CPF:</strong> {{ data.cpf || '—' }}
              </v-col>
              <v-col cols="12" md="4">
                <strong>País de origem:</strong> {{ data.country_of_origin || '—' }}
              </v-col>
            </v-row>
            <v-row dense class="mt-2 border-sm pa-4 rounded-lg">
              <!-- Contatos -->
              <v-col cols="12" md="6">
                <strong>E-mail principal:</strong> {{ data.primary_email || '—' }}
              </v-col>
              <v-col cols="12" md="6">
                <strong>E-mail alternativo:</strong> {{ data.alternative_email || '—' }}
              </v-col>
              <v-col cols="12" md="6">
                <strong>Telefones:</strong> {{ data.phones || '—' }}
              </v-col>
            </v-row>
            <v-row dense class="mt-2 border-sm pa-4 rounded-lg">
              <!-- Endereço -->
              <v-col cols="12" md="6">
                <strong>País:</strong> {{ data.country || '—' }}
              </v-col>
              <v-col cols="12" md="6">
                <strong>Estado:</strong> {{ data.state || '—' }}
              </v-col>
              <v-col cols="12" md="6">
                <strong>Cidade:</strong> {{ data.city || '—' }}
              </v-col>
              <v-col cols="12" md="6">
                <strong>Bairro:</strong> {{ data.district || '—' }}
              </v-col>
              <v-col cols="12" md="6">
                <strong>Rua:</strong> {{ data.street || '—' }}
              </v-col>
              <v-col cols="12" md="6">
                <strong>Complemento:</strong> {{ data.address_complement || '—' }}
              </v-col>
              <v-col cols="12" md="4">
                <strong>CEP:</strong> {{ data.zip_code || '—' }}
              </v-col>
            </v-row>
            <v-row dense class="mt-2 border-sm pa-4 rounded-lg">
            <!-- Escolaridade -->
            <v-col cols="12" md="6">
              <strong>Curso:</strong> {{ data.course || '—' }}
            </v-col>
            <v-col cols="12" md="6">
              <strong>Instituição de dataação:</strong> {{ data.graduation_institution || '—' }}
            </v-col>
            <v-col cols="12" md="4">
              <strong>Ano de dataação:</strong> {{ data.graduation_year || '—' }}
            </v-col>

            <!-- Trabalho -->
            <v-col cols="12" md="4">
              <strong>Empregado:</strong> {{ data.is_employed ? 'Sim' : 'Não' }}
            </v-col>
            <v-col cols="12" md="4">
              <strong>Tipo de trabalho:</strong> {{ data.job_type || '—' }}
            </v-col>
            <v-col cols="12" md="6">
              <strong>Empresa:</strong> {{ data.workplace || '—' }}
            </v-col>
            <v-col cols="12" md="6">
              <strong>Cargo:</strong> {{ data.job_position || '—' }}
            </v-col>
            <v-col cols="12" md="4">
              <strong>Desde:</strong> {{ data.working_since || '—' }}
            </v-col>

            <!-- Necessidades especiais -->
            <v-col cols="12" md="4">
              <strong>Possui necessidades especiais:</strong> {{ data.has_special_needs ? 'Sim' : 'Não' }}
            </v-col>
            <v-col cols="12" md="8" v-if="data.has_special_needs">
              <strong>Descrição:</strong> {{ data.special_needs_description || '—' }}
            </v-col>
            </v-row>
          </v-container>
        </v-card-text>
        <v-divider></v-divider>
        <v-card-actions class="bg-secondary d-flex justify-center">
          <v-btn color="blue-darken-1" variant="outlined" @click="close()">
            Cancelar
          </v-btn>
          <v-btn color="primary" variant="elevated" to='/'>
            Confirmar Inscrição
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>
<script>
export default {
  props: {
    confirmSave: {
      type: Boolean,
      default: null
    },
    deleteId: {
      type: Number,
      default: null
    },
    data: {
      type: Object,
      default: () => ({})
    }
  },
  computed: {
    candidateDisplayName() {
      return this.data.social_name || this.data.full_name || '—';
    }
  },
  methods: {
    close() {
      this.$emit('close');
    },
  },
}
</script>